import { EFinancingProgram, ELoanPurpose } from '@if/core/types'
import { Constants } from '@src/data/types/constants'

// A merchant's service category doubles as the application's loan purpose — the backend copies
// one onto the other on create (SetLoanPurpose) — so either value identifies a Medicard file.
const MEDICAL_SERVICE_CATEGORIES: ELoanPurpose[] = [
  ELoanPurpose.Medical,
  ELoanPurpose.Dentistry,
  ELoanPurpose.Aesthetics,
]

export const isMedicardCategory = (category: ELoanPurpose | null | undefined): boolean =>
  !!category && MEDICAL_SERVICE_CATEGORIES.includes(category)

// Personal narrows the resolved config's maximum: a Medicard category may reach the program
// ceiling, every other category is held below it. Never raises the config — a merchant override
// lower than the category cap still wins.
export const resolveMaxLoanAmount = (
  financingProgramId: EFinancingProgram | null | undefined,
  configMaxLoanAmount: number,
  category: ELoanPurpose | null | undefined,
): number => {
  if (financingProgramId !== EFinancingProgram.Personal) return configMaxLoanAmount

  const personalConfig = Constants.financingProgramConfigs[EFinancingProgram.Personal]
  const categoryMax = isMedicardCategory(category) ? personalConfig.maxLoanAmountMedicard : personalConfig.maxLoanAmount

  return categoryMax != null && categoryMax > 0 ? Math.min(categoryMax, configMaxLoanAmount) : configMaxLoanAmount
}
